import _JSXStyle from "styled-jsx/style";
import { UserAvatar } from '@dhis2-ui/user-avatar';
import PropTypes from 'prop-types';
import React, { useCallback, useRef, useState } from 'react';
import { DebugInfoModal } from './debug-info/debug-info-modal.js';
import i18n from './locales/index.js';
import { ProfileMenu } from './profile-menu/index.js';
import { useOnDocClick } from './profile/use-on-doc-click.js';

const Profile = _ref => {
  let {
    name,
    email,
    avatarId,
    helpUrl
  } = _ref;
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [showDebugInfoModal, setShowDebugInfoModal] = useState(false);
  const hideProfileMenu = useCallback(() => setShowProfileMenu(false), [setShowProfileMenu]);
  const toggleProfileMenu = useCallback(() => setShowProfileMenu(show => !show), [setShowProfileMenu]);
  const containerRef = useRef(null);
  useOnDocClick(containerRef, hideProfileMenu);
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    "data-test": "headerbar-profile",
    className: "jsx-3442481507" + " " + "headerbar-profile"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: toggleProfileMenu,
    title: i18n.t('header bar profile'),
    "aria-label": i18n.t('header bar profile'),
    className: "jsx-3442481507" + " " + "headerbar-profile-btn"
  }, /*#__PURE__*/React.createElement(UserAvatar, {
    avatarId: avatarId,
    name: name,
    dataTest: "headerbar-profile-icon",
    medium: true
  })), showProfileMenu && /*#__PURE__*/React.createElement(ProfileMenu, {
    avatarId: avatarId,
    name: name,
    email: email,
    helpUrl: helpUrl,
    hideProfileMenu: hideProfileMenu,
    showDebugInfoModal: () => {
      setShowDebugInfoModal(true);
    }
  }), showDebugInfoModal && /*#__PURE__*/React.createElement(DebugInfoModal, {
    onClose: () => {
      setShowDebugInfoModal(false);
    }
  }), /*#__PURE__*/React.createElement(_JSXStyle, {
    id: "3442481507"
  }, [".headerbar-profile.jsx-3442481507{position:relative;height:100%;}", ".headerbar-profile-btn.jsx-3442481507{background:transparent;padding:6px;border:0;cursor:pointer;}", ".headerbar-profile-btn.jsx-3442481507:focus{outline:2px solid white;outline-offset:-2px;}", ".headerbar-profile-btn.jsx-3442481507:focus.jsx-3442481507:not(:focus-visible){outline:none;}", ".headerbar-profile-btn.jsx-3442481507:hover{background:#1a557f;}", ".headerbar-profile-btn.jsx-3442481507:active{background:#104067;}"]));
};

Profile.propTypes = {
  name: PropTypes.string.isRequired,
  avatarId: PropTypes.string,
  email: PropTypes.string,
  helpUrl: PropTypes.string
};
export default Profile;